// extracted by mini-css-extract-plugin
module.exports = {"vipBadge":"VipBadge_vipBadge__jP_lm"};